import { Phone, Mail, MapPin, Clock, AlertCircle } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-foreground text-background safe-bottom">
      <div className="container mx-auto px-4 py-10 sm:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10">
          {/* Company Info */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">ANEMT</h3>
            <p className="text-sm opacity-80 mb-3 sm:mb-4 leading-relaxed">
              Reliable non-emergency medical transportation in Portland, OR.
            </p>
            <p className="text-xs opacity-60">
              Licensed • Insured • Wheelchair Accessible
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-base sm:text-lg">Quick Links</h4>
            <ul className="space-y-2 sm:space-y-2.5 text-sm">
              <li><Link to="/" className="opacity-80 hover:opacity-100 transition-opacity">Home</Link></li>
              <li><Link to="/services" className="opacity-80 hover:opacity-100 transition-opacity">Services</Link></li>
              <li><Link to="/pricing" className="opacity-80 hover:opacity-100 transition-opacity">Pricing</Link></li>
              <li><Link to="/contact#booking-form" className="opacity-80 hover:opacity-100 transition-opacity">Request a Ride</Link></li>
              <li><Link to="/faq" className="opacity-80 hover:opacity-100 transition-opacity">FAQ</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-base sm:text-lg">Contact</h4>
            <ul className="space-y-2.5 sm:space-y-3 text-sm">
              <li className="flex items-start">
                <Phone className="h-4 w-4 mr-2 mt-0.5 flex-shrink-0" />
                <a href="tel:9713445446" className="opacity-80 hover:opacity-100 transition-opacity">971-344-5446</a>
              </li>
              <li className="flex items-start">
                <Mail className="h-4 w-4 mr-2 mt-0.5 flex-shrink-0" />
                <a href="mailto:support@anemt.org" className="opacity-80 hover:opacity-100 transition-opacity break-all">support@anemt.org</a>
              </li>
              <li className="flex items-start">
                <MapPin className="h-4 w-4 mr-2 mt-0.5 flex-shrink-0" />
                <span className="opacity-80">Portland Metro Area</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div className="col-span-2 md:col-span-1">
            <h4 className="font-semibold mb-3 sm:mb-4 text-base sm:text-lg">Hours</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start">
                <Clock className="h-4 w-4 mr-2 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="opacity-80">Available by appointment</p>
                </div>
              </div>
              <p className="text-xs opacity-70 p-3 bg-background/10 rounded-xl leading-relaxed">
                <strong>Important:</strong> Private-pay only. We do not bill Medicare or Medicaid.
              </p>
            </div>
          </div>
        </div>

        {/* Emergency Notice */}
        <div className="mt-8 sm:mt-10 mb-6 sm:mb-8">
          <div className="max-w-3xl mx-auto">
            <div className="bg-destructive/90 rounded-xl p-3 sm:p-4 shadow-lg">
              <div className="flex items-center justify-center gap-2 sm:gap-3">
                <AlertCircle className="h-5 w-5 text-destructive-foreground flex-shrink-0" />
                <p className="text-sm sm:text-base text-destructive-foreground font-semibold text-center">
                  We are NOT an emergency service. For medical emergencies, call 911.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background/20 pt-6 sm:pt-8 text-center text-sm opacity-60">
          <p>&copy; 2023 ANEMT. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
